export default {
  install() {
    let loglevel = {
      none : 0,
      error : 1,
      warn: 2,
      info : 3,
      debug : 4,
    }

    if(loglevel.error > process.env.VUE_APP_LOG_LEVEL){
      console.error = function(){}
      console.assert = function(){}
    }

    if(loglevel.warn > process.env.VUE_APP_LOG_LEVEL){
      console.warn = function(){}
      console.countRest = function(){}
    }

    if(loglevel.info > process.env.VUE_APP_LOG_LEVEL){
      console.count = function(){}
      console.info = function(){}
      console.timeEnd = function(){}
    }

    if(loglevel.debug > process.env.VUE_APP_LOG_LEVEL){
      console.log = function(){}
      console.trace = function(){}
      console.dir = function(){}
      console.dirxml = function(){}
      console.group = function(){}
      console.groupCollapsed = function(){}
      console.debug = function(){}
      console.timeLog = function(){}
    }
  }
}